module.exports = __webpack_public_path__ + "img/nav-m-2.b311d578.png";